import React from 'react';

import { MARKETING_EMAIL_CONSENT_COPY } from '../../constants/legal';
import { FILLS, FONTS } from '../../styles/tokens';

interface MarketingEmailConsentProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  /** Marks the control busy while a save is in flight. */
  busy?: boolean;
}

const MarketingEmailConsent: React.FC<MarketingEmailConsentProps> = ({
  id,
  checked,
  onChange,
  disabled = false,
  busy = false,
}) => (
  <label
    htmlFor={id}
    style={{
      display: 'flex',
      alignItems: 'flex-start',
      gap: '10px',
      cursor: disabled ? 'not-allowed' : 'pointer',
    }}
  >
    <input
      id={id}
      type="checkbox"
      checked={checked}
      onChange={(event) => onChange(event.target.checked)}
      disabled={disabled}
      aria-busy={busy}
      style={{
        width: '18px',
        height: '18px',
        accentColor: FILLS.gold,
        marginTop: '1px',
        flexShrink: 0,
        cursor: 'inherit',
      }}
    />
    <span
      style={{
        fontSize: '13px',
        color: FILLS.textLight,
        fontFamily: FONTS.body,
        lineHeight: 1.5,
      }}
    >
      {MARKETING_EMAIL_CONSENT_COPY}
    </span>
  </label>
);

export default MarketingEmailConsent;
